// extracted by mini-css-extract-plugin
export default {"root":"popup_root__58xtT"};